$(document).ready(function () {

    $('.js-toggle-vat').on('change', function (e) {
        SwitchVAT();
    });


});